import { api } from '~/services/api';

export const getRoutes = () => api.get(`/routes`);

export const getGlobalRoute = () =>
  api.get(`/routes?showDisabled=true&&global=true`);

export const getRoutesTimes = id =>
  api.get(`/trips/available-times?route=${id}`);
